@if (isLoading) {
  <palantir-table-skeleton />
} @else {
  @if (isSearching) {
    <palantir-progress-bar mode="indeterminate" />
  }

  @if (data.dataSource.length) {
    <cdk-table [dataSource]="data.dataSource" class="palantir-table palantir-scrollbar">
      @for (column of displayedColumns; track $index) {
        @if (column !== 'action' && column !== 'checkbox') {
          <ng-container [cdkColumnDef]="column">
            <cdk-header-cell *cdkHeaderCellDef>
              <div
                class="palantir-table__header"
                (click)="data.displayedColumns[$index].sortable ? sortData(column) : null"
                (keypress.enter)="data.displayedColumns[$index].sortable ? sortData(column) : null"
                [ngClass]="{
                  'palantir-table__header--sortable': data.displayedColumns[$index].sortable,
                }"
              >
                <palantir-text [type]="selectedSort().active === column ? 'title' : 'subtitle'">
                  {{ data.displayedColumns[$index].label }}
                </palantir-text>

                @if (data.displayedColumns[$index].icon) {
                  <palantir-icon [name]="data.displayedColumns[$index].icon" />
                }

                @if (data.displayedColumns[$index].sortable) {
                  <palantir-icon
                    class="palantir-table__sort-icon"
                    name="arrow-upward-outline"
                    [ngClass]="{
                      'palantir-table__sort-icon--desc':
                        selectedSort().active === column && selectedSort().direction === 'desc',
                      'palantir-table__sort-icon--active': selectedSort().active === column,
                    }"
                  />
                }
              </div>
            </cdk-header-cell>

            <cdk-cell *cdkCellDef="let element">
              @switch (element[column]?.type) {
                @case ('STARS') {
                  <palantir-stars [value]="element[column].value" />
                }
                @case ('STATUS') {
                  <palantir-status
                    [value]="element[column].value"
                    [label]="element[column].label"
                  />
                }
                @case ('TAGS') {
                  <palantir-tags
                    [tags]="element[column].tags"
                    labelTranslate="Etiquetas"
                    [emptyText]="element[column].emptyText"
                  />
                }
                @case ('AVATAR') {
                  <palantir-table-avatar
                    [value]="element[column].value"
                    [label]="element[column].label"
                    [icon]="element[column].icon"
                    (click)="element[column].action?.(element[column])"
                    [clickable]="!!element[column].action"
                  />
                }
                @case ('TEXT') {
                  @if (element[column].value || !element[column].emptyText) {
                    <palantir-text
                      type="text"
                      truncate="true"
                      [palantirTooltip]="element[column].value"
                      [palantirTooltipDisabled]="element[column]?.value?.length < 50"
                    >
                      {{ element[column].value }}
                    </palantir-text>
                  } @else {
                    <palantir-text empty="true" type="description" truncate="true">
                      {{ element[column].emptyText }}
                    </palantir-text>
                  }
                }
                @case ('AVATAR_GROUP') {
                  <palantir-table-avatar-group
                    [avatars]="element[column].values"
                    [maxItems]="element[column].maxItems"
                    [extraItemsTooltip]="element[column].extraItemsTooltip"
                    [action]="element[column].action"
                  />
                }
                @case ('DROPDOWN') {
                  <palantir-table-dropdown
                    [element]="element[column]"
                    [blockScroll$]="blockScroll$"
                  />
                }
                @case ('LOADING') {
                  <palantir-table-loading />
                }
                @case ('CUSTOM') {
                  <ng-container
                    *ngTemplateOutlet="
                      customTemplates[column];
                      context: { $implicit: element[column] }
                    "
                  />
                }
              }
            </cdk-cell>
          </ng-container>
        }
      }

      <ng-container cdkColumnDef="checkbox">
        <cdk-header-cell *cdkHeaderCellDef>
          <div class="cdk-column-checkbox__wrapper">
            <palantir-checkbox
              (click)="toggleAllRows()"
              [attr.aria-selected]="selection.hasValue() && isAllSelected()"
              [attr.indeterminate]="selection.hasValue() && !isAllSelected()"
            />

            <palantir-icon
              class="palantir-table__expand-icon"
              name="expand-more-outline"
              [cdkMenuTriggerFor]="menu"
            />
          </div>

          <ng-template #menu>
            <palantir-content class="palantir-menu palantir-table__menu" cdkMenu>
              <ng-content select="[palantir-table-checkbox-menu], palantir-table-checkbox-menu" />
            </palantir-content>
          </ng-template>
        </cdk-header-cell>
        <cdk-cell *cdkCellDef="let element">
          <palantir-checkbox
            (click)="selection.toggle(element)"
            [attr.aria-selected]="selection.isSelected(element)"
          />
        </cdk-cell>
      </ng-container>

      <ng-container cdkColumnDef="action" stickyEnd>
        <cdk-header-cell *cdkHeaderCellDef>
          <palantir-text type="subtitle">
            {{ data.displayedColumns[data.displayedColumns.length - 1].label }}
          </palantir-text>
        </cdk-header-cell>

        <cdk-cell *cdkCellDef="let element">
          @let isDisabled = element['action']?.disabled;

          <palantir-button
            theme="transparent"
            layout="icon"
            shape="rounded"
            size="2xs"
            [icon]="element['action']?.icon || 'edit-filled'"
            (click)="element['action']?.action(element['action'], $event)"
            [attr.disabled]="isDisabled"
          />
        </cdk-cell>
      </ng-container>

      <cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" />
      <cdk-row *cdkRowDef="let column; columns: displayedColumns" />
    </cdk-table>

    <ng-content select="[palantir-table-footer], palantir-table-footer" />
  } @else {
    <ng-content select="[palantir-table-empty-state], palantir-table-empty-state" />
  }
}
